import _ from 'lodash'

const wrappingLines = _.throttle(function() {
  const container = this
  const spans = container.children
  var top = 0
  var tmp = ''
  const opentag = '<span class="hero__text-inner">'
  const closingtag = '</span>'

  if (container.textContent === undefined) {
    return
  }

  container.innerHTML = container.textContent.replace(/\S+/g, '<n>$&</n>')
  for (let i = 0; i < spans.length; i++) {
    const rect = spans[i].getBoundingClientRect().top

    if (top < rect) {
      tmp += closingtag + opentag
    }

    top = rect
    tmp += spans[i].textContent + ' '
  }

  container.innerHTML = tmp += closingtag
  container.classList.add('hero__text--rendered')
}, 1000)

const directive = {
  inserted(containerElement) {
    const container = containerElement.querySelector('.hero__text')
    if (container === undefined) {
      return
    }

    _.forEach(['resize', 'orientationchange'], item => {
      window.addEventListener(item, wrappingLines.bind())
    })

    wrappingLines.bind(container)()
  },
  unbind(containerElement) {
    const container = containerElement.querySelector('.hero__text')
    if (container === undefined) {
      return
    }

    _.forEach(['resize', 'orientationchange'], item => {
      window.removeEventListener(item, wrappingLines.bind(container))
    })
  }
}

export default directive
